export const DashboardSpecialOrderTableHeaders = [
  {
    Header: "Order#",
    accessor: "orderNumber",
  },
  {
    Header: "Style",
    accessor: "style",
  },

  {
    Header: "Company",
    accessor: "company",
  },
  {
    Header: "Full Name",
    accessor: "name",
  },
  {
    Header: "Phone",
    accessor: "phone",
  },
  {
    Header: "Arrival Date",
    accessor: "arrivalDate",
  },
  {
    Header: "Event Date",
    accessor: "eventDate",
  },

  {
    Header: "Location",
    accessor: "location",
  },
];

export const DashboardSpecialOrderMiniTableHeaders = [

  {
    Header: "Style",
    accessor: "style",
  },

  {
    Header: "Company",
    accessor: "company",
  },
  {
    Header: "Full Name",
    accessor: "name",
  },

  {
    Header: "Event Date",
    accessor: "eventDate",
  }
];
